<template>
  <div id="login">
    <!-- <div class="login-content__tab mar-b-30">
      <div :class="['login-content__tab__item ipub-h3 active']">
        <template>Sign In</template>
      </div>
      <div :class="['login-content__tab__item ipub-h3 mar-l-40']">
        <router-link to="register">Sign Up</router-link>
      </div>
    </div> -->
    <ipub-form ref="login-form"
               :model="form"
               :rules="rules">
      <ipub-form-item prop="email"
                      label="Email">
        <ipub-input v-model.trim="form.email"
                    autocomplete="on"
                    placeholder="Email" />
      </ipub-form-item>
      <ipub-form-item prop="password"
                      label="">
        <div class="mar-b-10 ipub-p2 fw-bd relative ipub-cursor-pointer"
             slot="label">
          Password<font class="key-color">*</font>
          <ipub-tooltip placement="right"
                        type="dark"
                        action="click"
                        class="mar-l-10">
            <div slot="title">1. Password can be a combination of 6-20 digits, letters, and punctuations, but not spaces.<br />
              2. Include at least two numbers, letters, and punctuations.<br />
              3. Letters are case sensitive.</div>
            <ipub-icon style="display:inline-block"
                       type="iconInfo" />
          </ipub-tooltip>
        </div>
        <ipub-input password
                    autocomplete="on"
                    v-model.trim="form.password"
                    placeholder="Password" />
      </ipub-form-item>
    </ipub-form>
    <ipub-button style="width:100%;margin-bottom:20px;margin-top: 4px;"
                 type="primary"
                 @click="submit">
      Sign In
    </ipub-button>
    <div class="ipub-p3 link-color mar-b-10">
      <ipub-icon :class="['mar-l-10 rotate','rotate-270']"
                 type="iconArrow" />
      <router-link to="forget"> Forget your password?</router-link>
    </div>
    <div class="ipub-p3 font-color mar-b-10">
      <font class="link-color">
        <ipub-icon :class="['mar-l-10 rotate','rotate-270']"
                   type="iconArrow" />
      </font>
      Not registered yet?
      <router-link to="register"
                   class="link-color">Register now</router-link>.
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
